export default "__VITE_ASSET__5AMO9yP0__"